import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import { connect } from 'react-redux';
import { Layout, Button, Menu, Dropdown } from 'antd';
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  DownOutlined,
  ShopOutlined,
} from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import IconFont from '@/components/IconFont';
import { storage } from '@/utils';
import * as CardApi from '@/api/card';
import { toggleSiderCollapsed } from '@/redux/actions/user';
// import { toggleHandoverModalVisible } from '@/redux/actions/handover';
import { setRoomCardEnabled, setEnabledVerndor } from '@/redux/actions/card';

import intl from 'react-intl-universal';

import { DoorLockCode } from '@/pages/device/card/interface';
import { MyDoorLockCardClass, SingleCardProxyClass } from '@/components/Cards/components/helper';
import ReadDoorCardModal from '@/components/Cards/components/ReadDoorCardModal';
import ReadCardModal from '@/components/Cards/read';
import { LockVendor, LockVendorMap } from '@/components/Cards/config';
import { FUNCTION_ICON } from '@/components/SystermSettingsModal/components/QuickKey/helper';
import SystermSettingsModal from '@/components/SystermSettingsModal';

import useSendShopInfo from '@/hooks/useSendShopInfo';
import { fetchIdCardList } from '@/api/computer';
import { PERM_CODES } from '@/config';
import { TenantSignStorage } from '@/utils/intl';

import HeaderMenu from './headerMenu';
import styles from './header.module.scss';

const { Header } = Layout;

export interface PmsHeaderRef {
  openQuickEntry: () => void;
}

const PmsHeader = forwardRef<PmsHeaderRef, any>((props, ref) => {
  const {
    permissions,
    roomCardEnabled,
    enabledVendor,
    shortcuts,
    handleNewCard,
    handleInvite,
    handleHandover,
    handleReservePortal,
    handleCheckInPortal,
  } = props;

  const { storePageEntry = [], groupPageEntry = [] } = shortcuts;
  const history = useHistory();

  const [collapsed, setCollapsed] = useState(false);
  const [readModalVisible, setReadModalVisible] = useState(false);
  const settingsModalRef = useRef<any>(null);

  const readRef = useRef<any>();

  // 初始化 send service
  const { sendServive } = useSendShopInfo();

  // 商户logo
  const logo = TenantSignStorage.getLocalConfig()?.icon3x;

  const filterEmptyData = (data) => {
    return data.filter((item) => {
      if (item.func && (item.key || item.id)) {
        return true;
      }
      if (item.menu && (item.key || item.id)) {
        return true;
      }
      return false;
    });
  };
  // 获取房卡启用状态
  const initCardEnableState = async () => {
    try {
      Promise.all([CardApi.fetchCardEnable(), fetchIdCardList()]).then(async ([res, idCardRes]) => {
        const params: any = {};
        if (res && res.data) {
          const lockItem = { ...res?.data };
          props.setRoomCardEnabled(true);
          props.setEnabledVerndor(lockItem);

          // 走本地独立java服务
          if (lockItem?.lockCode === DoorLockCode.BE_LINE) {
            try {
              const ipcRes = await window.electron.ipcRenderer.restartIotPlugin(
                storage.get('commonCode'),
              );
              // console.log('ipcRes', ipcRes);
              setTimeout(() => {
                const cardInstance: MyDoorLockCardClass = new SingleCardProxyClass();
                cardInstance.setOpen({
                  lockType: LockVendorMap[lockItem?.lockCode],
                  commonCode: storage.get('commonCode'),
                });
              }, 10000);
            } catch (e) {
              //
            }
          } else {
            // 切换门店，启动初始插件
            if (lockItem?.lockCode) {
              params.DoorCardAuthorizer = `${lockItem?.lockCode}_DoorCard_Authorizer`;
            }
          }
        } else {
          props.setRoomCardEnabled(false);
          props.setEnabledVerndor(null);
        }

        const currentIdCardCode = idCardRes?.data?.find((item) => item.status === 1)
          ?.identificationCode;
        if (currentIdCardCode) {
          params.IDCardReader = currentIdCardCode;
        }
        if (params.DoorCardAuthorizer || params.IDCardReader) {
          // 先同步接口当前启用设备到本地plugin文件，然后拉起exe，(若重启调用reStartByPluginJson通知c++设备更新)
          window?.electron?.ipcRenderer.restartPlugin(params);
        }
      });
    } catch (err) {
      props.setRoomCardEnabled(false);
      props.setEnabledVerndor(null);
    }
  };

  const toggleCollapsed = () => {
    const collapsedFlag = !collapsed;
    setCollapsed(collapsedFlag);
    props.toggleSiderCollapsed(collapsedFlag);
    storage.set('collapsed', collapsedFlag);
  };

  const groupClickMenu = ({ item, key }) => {
    if (key === 'costumnQuickEntry') {
      settingsModalRef.current?.setTabKey('quickEntry');
      settingsModalRef.current?.openModal({
        priceChannel: 'CRS',
      });
    } else {
      const data = item.props['data-item'];
      history.push(data.path);
    }
  };

  const clickMenu = ({ item, key }) => {
    if (key === 'costumnQuickEntry') {
      settingsModalRef.current?.setTabKey('quickEntry');
      settingsModalRef.current?.openModal({
        priceChannel: 'CRS',
      });
    } else {
      const data = item.props['data-item'];

      if (data.menu) {
        history.push(data.path);
      }

      if (data.func) {
        // 功能
        switch (key) {
          case 'newReservation': // 新预订
            handleReservePortal();
            break;
          case 'newCheckIn': // 新入住
            handleCheckInPortal();
            break;
          case 'newMemberCard': // 新办会员卡
            handleNewCard();
            break;
          case 'centralReservation': //  中央预订邀请单
            handleInvite();
            break;
          case 'readRoomCard': //  读房卡
            if (enabledVendor?.lockCode === DoorLockCode.BE_LINE) {
              readRef.current.openModal();
            } else {
              setReadModalVisible(true);
            }
            break;
          case 'handover': //  交班;
            handleHandover();
            break;
          default:
            break;
        }
      }
    }
  };

  useEffect(() => {
    const cacheCollapsed = storage.get('collapsed');
    setCollapsed(cacheCollapsed === 'true');
    props.toggleSiderCollapsed(cacheCollapsed === 'true');

    // when logined, check handover & cardEnabled status
    const commonCode = storage.get('commonCode');
    if (commonCode) {
      // 发送commonCode 到c++
      if (!storage.get('isGroupLogin')) sendServive(storage.get('commonCode'));

      setTimeout(() => {
        initCardEnableState();
      }, 2000);
    }

    return () => {};
  }, []);

  const dynamicIcon = (item) => {
    if (item?.icon) {
      return <IconFont type={item.icon} />;
    }
    if (FUNCTION_ICON[item?.key]) {
      return <IconFont type={FUNCTION_ICON[item?.key]} />;
    }
    return null;
  };
  const dropdownMenu = () => {
    // 集团
    if (storage.get('isGroupLogin')) {
      return (
        <Menu onClick={groupClickMenu}>
          {filterEmptyData(groupPageEntry).map((item) => (
            <Menu.Item
              style={{ lineHeight: '32px' }}
              key={item.key || item.func || item.id}
              icon={dynamicIcon(item)}
              data-item={item}
            >
              {item.name}
            </Menu.Item>
          ))}
          {/* <Menu.Item style={{ lineHeight: '32px' }} key="incomeForecast" icon={<ShopOutlined />}>
            {intl.get('app_forecast_detail')}
          </Menu.Item> */}
          {filterEmptyData(groupPageEntry).length > 0 && <div className={styles.devider} />}
          <Menu.Item
            style={{ lineHeight: '32px' }}
            key="costumnQuickEntry"
            icon={<IconFont type="icon-zidingyikuaijierukou" />}
          >
            {intl.get('app_custom_quick_entry')}
          </Menu.Item>
        </Menu>
      );
    }
    // 门店
    return (
      <Menu onClick={clickMenu}>
        {/* {roomCardEnabled && (
          <>
            <Menu.Item
              style={{ lineHeight: '32px' }}
              key="readCard"
              icon={<IconFont type="icon-dufangka" />}
            >
              {intl.get('app_read_room_card')}
            </Menu.Item>
          </>
        )}
        {permissions?.includes(PERM_CODES.CRS_PRODUCT_INFO) && (
          <>
            <Menu.Item
              style={{ lineHeight: '32px' }}
              key="crsInvitation"
              icon={<IconFont type="icon-zhongyangyudingyaoqingdan" />}
            >
              {intl.get('order_submenu_crsInvitation')}
            </Menu.Item>
          </>
        )} */}
        {filterEmptyData(storePageEntry).map((item) => (
          <Menu.Item
            style={{ lineHeight: '32px' }}
            key={item.key || item.func || item.id}
            icon={dynamicIcon(item)}
            data-item={item}
          >
            {item.name}
          </Menu.Item>
        ))}
        {filterEmptyData(storePageEntry).length > 0 && <div className={styles.devider} />}
        <Menu.Item
          style={{ lineHeight: '32px' }}
          key="costumnQuickEntry"
          icon={<IconFont type="icon-zidingyikuaijierukou" />}
        >
          {intl.get('app_custom_quick_entry')}
        </Menu.Item>
      </Menu>
    );
  };

  useImperativeHandle(ref, () => ({
    openQuickEntry: () => {
      settingsModalRef.current?.openModal({
        priceChannel: 'CRS',
      });
    },
  }));

  return (
    <>
      <Header className={styles.layoutHeader}>
        <div className={styles.headerLeft}>
          <div className={styles.headerLogo} style={{ width: collapsed ? 64 : 156 }}>
            {/* <div className={styles.headerLogoImg} /> */}
            <img src={logo} alt="logo" className={styles.headerLogoImg} />
            {collapsed ? '' : <div className={styles.headerLogoText}>YooPMS</div>}
          </div>
          <Button
            className={styles.triggerBtn}
            onClick={toggleCollapsed}
            icon={React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined)}
          />
          <HeaderMenu />
        </div>
        <div className={styles.headerRight}>
          {enabledVendor?.lockCode === DoorLockCode.BE_LINE ? (
            <ReadDoorCardModal
              innerRef={readRef}
              enabledVendor={enabledVendor}
              readCallBack={() => readRef.current.closeModal()}
            />
          ) : (
            <ReadCardModal
              readModalVisible={readModalVisible}
              readCallBack={() => {
                setReadModalVisible(false);
              }}
            />
          )}

          <Dropdown overlay={dropdownMenu()} getPopupContainer={(e) => e.parentElement}>
            <div className={styles.dropdownContent}>
              {intl.get('app_system_shortcut')}
              <div className={styles.dropdownIcon}>
                <DownOutlined />
              </div>
            </div>
          </Dropdown>
        </div>
      </Header>
      <SystermSettingsModal ref={settingsModalRef} />
    </>
  );
});

const mapStateToProps = (state) => {
  const { permissions, shortcuts } = state.user;
  const { roomCardEnabled, enabledVendor } = state.card;
  return { permissions, roomCardEnabled, enabledVendor, shortcuts };
};

// 添加 {forwardRef: true} 选项到 connect
export default connect(
  mapStateToProps,
  {
    toggleSiderCollapsed,
    // toggleHandoverModalVisible,
    setRoomCardEnabled,
    setEnabledVerndor,
  },
  null,
  { forwardRef: true },
)(PmsHeader);
